import type { RouteRecordRaw } from 'vue-router'

export const seniorRoutes: RouteRecordRaw[] = [
  {
    path: '/senior',
    name: routeNames.senior,
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: {
      requiresAuth: true,
      role: 'senior'
    },
    children: [
      {
        path: 'compose-request',
        name: routeNames.seniorComposeRequest,
        component: () => import('@/components/AppRouterView.vue'),
        redirect: { name: routeNames.seniorComposeRequestChat },
        children: [
          {
            path: 'chat',
            name: routeNames.seniorComposeRequestChat,
            component: () => import('@/views/senior/compose-request/SeniorComposeRequestChat.vue')
          },
          {
            path: 'manual',
            name: routeNames.seniorComposeRequestManual,
            component: () => import('@/views/senior/compose-request/SeniorComposeRequestManual.vue')
          },
          {
            path: 'review',
            name: routeNames.seniorComposeRequestReview,
            component: () => import('@/views/senior/compose-request/SeniorComposeRequestReview.vue')
          },
          {
            path: 'success',
            name: routeNames.seniorComposeRequestSuccess,
            component: () => import('@/views/senior/compose-request/SeniorComposeRequestSuccess.vue')
          }
        ]
      },
      {
        path: 'my-requests',
        name: routeNames.seniorMyRequests,
        component: () => import('@/components/AppRouterView.vue'),
        redirect: { name: routeNames.seniorMyRequestsList },
        children: [
          {
            path: '',
            name: routeNames.seniorMyRequestsList,
            component: () => import('@/views/senior/my-requests/SeniorMyRequests.vue')
          },
          {
            path: ':id',
            name: routeNames.seniorMyRequestDetail,
            component: () => import('@/views/senior/my-requests/SeniorMyRequestDetail.vue')
          },
          {
            path: ':id/edit',
            name: routeNames.seniorMyRequestEdit,
            component: () => import('@/views/senior/my-requests/SeniorMyRequestEdit.vue')
          }
        ]
      },
      {
        path: 'profile',
        name: routeNames.seniorProfile,
        component: () => import('@/views/senior/SeniorProfile.vue')
      }
    ]
  },

  {
    path: '/senior/profile',
    component: () => import('@/layouts/FormLayout.vue'),
    meta: {
      requiresAuth: true,
      role: 'senior',
      backToLink: routeNames.seniorProfile
    },
    children: [
      {
        path: 'info',
        name: routeNames.seniorProfileInfo,
        component: () => import('@/views/senior/profile/SeniorProfileInfo.vue')
      },
      {
        path: 'phone',
        name: routeNames.seniorProfilePhone,
        component: () => import('@/views/profile/ProfilePhone.vue'),
        meta: {
          successRedirect: routeNames.seniorProfile
        }
      },
      {
        path: 'emergency-contact',
        name: routeNames.seniorProfileEmergencyContact,
        component: () => import('@/views/senior/profile/SeniorProfileEmergencyContact.vue')
      }
    ]
  }
]
